import { STATUSPAGE } from '@repo/ui';
import { HandleTeamReport, GetTeamReportList } from 'domain/usecases';
import { notifyError } from 'presentation/app/components/notify';
import { useService } from 'presentation/app/hooks/useService';
import { useAppSelector } from 'presentation/config/hooks/useRedux';
import {
  clearTeamReportList,
  saveTeamReportList,
} from 'presentation/config/store/reports/team-report-slice-list';
import { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';

import { downloadReport } from '../common/helpers/download-report';

export const useTeamReport = () => {
  const [loadingTeam, setLoadingTeam] = useState<STATUSPAGE>(
    STATUSPAGE.INITIAL,
  );
  const [loadingExport, setLoadingExport] = useState<STATUSPAGE>(
    STATUSPAGE.INITIAL,
  );

  const { reportService } = useService();

  const dispatch = useDispatch();
  const { listTeamReport, total } = useAppSelector(
    (state) => state.teamReportList,
  );

  const requestGetTeamReportList = useCallback(
    async (params: GetTeamReportList.Params) => {
      setLoadingTeam(STATUSPAGE.LOADING);

      try {
        const res = await reportService.getTeamReportList(params);
        dispatch(saveTeamReportList({ data: res.data, total: res.total }));
      } catch (err) {
        dispatch(clearTeamReportList());
        notifyError(err.message);
      } finally {
        setLoadingTeam(STATUSPAGE.DONE);
      }
    },
    [reportService, setLoadingTeam],
  );

  const handleTeamReport = useCallback(
    async (params: HandleTeamReport.Params) => {
      setLoadingExport(STATUSPAGE.LOADING);

      const { type } = params;

      try {
        const res = await reportService.handleTeamReport(params);
        const filename = `relatorio-equipe_${type}`;

        downloadReport(res.url, {
          filename,
          type,
        });
      } catch (err) {
        notifyError(err.message);
      } finally {
        setLoadingExport(STATUSPAGE.DONE);
      }
    },
    [reportService, setLoadingExport],
  );

  return {
    handleTeamReport: {
      request: handleTeamReport,
      loading: loadingExport === STATUSPAGE.LOADING,
    },
    getTeamReport: {
      request: requestGetTeamReportList,
      loading: loadingTeam === STATUSPAGE.LOADING,
      data: listTeamReport,
      total,
    },
  };
};
